module.exports = __webpack_public_path__ + "media/images/flags/jo-6d45f2e5af066bb08f7f518b0509491b.svg";